import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Graph from "react-graph-vis";
import LogoCliente from "./assets/LogoCliente.png";

const options = {
  layout: {
    hierarchical: {
      enabled: false,
      levelSeparation: 300,
      nodeSpacing: 2000,
      treeSpacing: 3000,
      blockShifting: false,
      edgeMinimization: false,
      parentCentralization: false,
      direction: "RL", // UD, DU, LR, RL
      sortMethod: "directed", // hubsize, directed
    },
  },
  edges: {
    color: "#000000",
    length: 200,
  },
  nodes: {
    shape: "box",
    scaling: {
      min: 10,
      max: 20,
      label: {
        min: 10,
        max: 20,
      },
    },
    physics: true,
  },
};
const Nodos = ({ nodos, permisos }) => {
  const [graphMode, setMode] = useState(true);
  const graph = {
    nodes: nodos.map((nodo, index) => {
      return {
        id: nodo.nodo,
        label: nodo.nombre,
        color: getColor(nodo),
        value: 20,
      };
    }),
    edges: nodos.flatMap((nodo) => {
      return nodo.aristas.map((arista) => {
        return {
          from: nodo.nodo,
          to: arista.nodoDestino,
        };
      });
    }),
  };

  const events = {
    doubleClick: function (event) {
      var { nodes } = event;
      const nodo = nodos.find((x) => x.nodo === nodes[0]);
      if (nodo) permisos.modificarNodo && history.push("/edit/" + nodo._id);
    },
  };

  const history = useHistory();
  return (
    <>
      <h1 style={{ textAlign: "center" }}>
        Nodos
        <label className="switch" style={{ marginLeft: 20 }}>
          <input type="checkbox" onClick={() => setMode(!graphMode)} />
          <span className="slider"></span>
        </label>
        {nodos.filter((x) => x.nodoInicial).length > 1 && (
          <p style={{ color: "red" }}>Hay mas de un nodo inicial!</p>
        )}
      </h1>
      {graphMode ? (
        <Graph
          graph={graph}
          options={options}
          events={events}
          style={{ height: "70vh" }}
        />
      ) : (
        <table className="nodos-table">
          <thead>
            <tr>
              <td>Número del nodo</td>
              <td>Nombre del nodo</td>
              <td>Número de aristas</td>
            </tr>
          </thead>
          <tbody>
            {nodos.map((nodo) => (
              <Nodo
                key={nodo._id}
                nodo={nodo}
                history={history}
                permisos={permisos}
              />
            ))}
          </tbody>
        </table>
      )}
      {permisos.crearNodo && (
        <div style={{ textAlign: "center" }}>
          <Link to="/new">
            <button className="floatingButton">+</button>
          </Link>
        </div>
      )}

      {graphMode && (
        <div className="floating-legends">
          <span
            style={{ padding: "1px 5px 0 5px", backgroundColor: "#DEC90B" }}
          />
          <small>Nodo inical</small>
          <br />
          <span
            style={{ padding: "1px 5px 0 5px", backgroundColor: "#D19100" }}
          />
          <small>Nodo final</small>
          <br />
          <br />
        </div>
      )}
      <div>
        <img src={LogoCliente} alt="LogoCliente" className="LogoCliente" />
      </div>
    </>
  );
};

const Nodo = ({ nodo, history, permisos }) => {
  return (
    <tr
      className={"nodo"}
      onClick={() =>
        permisos.modificarNodo && history.push("/edit/" + nodo._id)
      }
      style={{ backgroundColor: getColor(nodo) }}
    >
      <td>{nodo.nodo}</td>
      <td>{nodo.nombre}</td>
      <td>{nodo.aristas.length}</td>
    </tr>
  );
};
export default Nodos;

function getColor(nodo) {
  if (nodo.nodoInicial) {
    return "#DEC90B";
  } else if (nodo.nodoFinal) {
    return "#D19100";
  } else {
    return "#cccccc";
  }
}
